import { createContext } from "react";
import { Dealer, CoopInfo } from "@/interfaces";

export interface DealerContextProps {
  dealer?: Dealer;
  setDealer: (dealer?: Dealer) => void;
  coopInfo?: CoopInfo;
  setCoopInfo: (coopInfo?: CoopInfo) => void;
  setNewSession: () => void;
}

export const DealerContext = createContext<DealerContextProps>({
  dealer: undefined,
  setDealer: () => undefined,
  coopInfo: undefined,
  setCoopInfo: () => undefined,
  setNewSession: () => undefined,
});
